import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Trust Section - fade in with slide from right and scale
 */
export const animateTrustSection = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const card = element.querySelector('[class*="section"]') || element.querySelector('[class*="card"]');
    const grid = element.querySelector('[class*="grid"]') || element.querySelector('[class*="Grid"]');
    
    // Set initial state immediately to prevent flash
    if (card) {
      gsap.set(card, { opacity: 0, x: 80, scale: 0.95 });
    }
    if (grid) {
      gsap.set(grid, { opacity: 0, y: 50 });
    }
    
    const timer = setTimeout(() => {
      if (card) {
        gsap.to(card, {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        });
      }
      
      if (grid) {
        gsap.to(grid, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: grid,
            start: "top 85%",
            toggleActions: "play none none none",
            once: true,
          },
        });
      }
      
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

